/**
 * useAllSports — fetches the complete sports list across every page. The sports
 * API caps perPage at 10 and ignores larger values, so a single getItems() only
 * returns the first 10 of 13. Returns a plain array of all sports.
 */
export async function useAllSports() {
  const {items, getItems, totalPages} = useCrudApi('api/v2/sports');
  const all = [];
  await getItems(1, 100);
  all.push(...(items.value ?? []));
  for (let page = 2; page <= (totalPages.value || 1); page++) {
    await getItems(page, 100);
    all.push(...(items.value ?? []));
  }
  return all;
}
